const state = {
  currentBusinessAccount: null,
  listBank: [],
  listMomo: [],
  listBankAccount: [],
  listMomoAccount: [],
  listTransfer: [],
  totalTransfer: 0,
  listTopUp: [],
  listTransaction: [],
  totalTransaction: 0,
  listAllTransaction: [],
  availableBalance: null,
  listOutgoing: [],
  listIncoming: [],
  listVisaCards: []

}

export default state
